import React from 'react';
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';

import Typography from '@mui/material/Typography';
import Qualifikation from "../snippets/Qualifikation";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';


import Header from "./common/Header2";



const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  	...theme.typography.body2,
  	padding: theme.spacing(1),
  	textAlign: 'center',
  	color: theme.palette.text.secondary,
}));

function StartContent(props) {
	const { t, i18n } = useTranslation("",{lng: props.language});

  	let navigate = useNavigate(); 


	const callUrl = (url) => {
		navigate(url);
	};
	
	const [ref0, inView0] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref1, inView1] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref2, inView2] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});	
	
	const [ref3, inView3] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const hero = [ {
	  	"src": "Slide1HeroBewertungPage",
		"headline": "Immobilienbewertung",
		"slogan": "Slogan fehlt hier"
		}
	];


  	return (<>
	  			<Box>
					<Header hero={hero} embedded={props.props.embedded} logo="logo-bewertung.png"/>

	  			</Box>
				<Box sx={{ flexGrow: 1, display: {
							xs: 'block',
							sm: 'block',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  							
							} }}
				>
					<hr className="spacer"/>
						<Box sx={{paddingTop: "40px", paddingTop: "40px", display: {
																		xs: 'none',
																		sm: 'none',  
																		md: 'block',  
																		lg: 'block',  
																		xl: 'block',  																		
																		}}}
		  				>
						<center>
							<h2 style={{paddingTop: "40px", paddingBottom: "40px"}} class="headlineNewPoint">{t("immobilienbewertungIntro")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={2}>
					     		</Grid>
			        			<Grid item xs={8}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent1")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={2}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				






						<center>
							<h2 style={{paddingTop: "40px", paddingBottom: "20px"}} class="headlineNewPoint">{t("immobilienbewertungHeader2")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={2}>
					     		</Grid>
			        			<Grid item xs={8}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent2")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={2}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={2}>
					     		</Grid>
			        			<Grid item xs={8}>
									<Box sx={{paddingTop: "20px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent2b")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={2}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				

						<center>
							<h2 style={{paddingTop: "40px", paddingBottom: "20px"}} class="headlineNewPoint">{t("immobilienbewertungHeader3")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={2}>
					     		</Grid>
			        			<Grid item xs={8}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent3")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={2}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				

						<center>
							<h2 style={{paddingTop: "40px", paddingBottom: "20px"}} class="headlineNewPoint">{t("immobilienbewertungHeader4")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={2}>
					     		</Grid>
			        			<Grid item xs={8}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent4")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={2}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				

						</Box>
						
	
		  				<Box sx={{paddingTop: "40px", paddingTop: "40px", display: {
																		xs: 'block',
																		sm: 'block',  
																		md: 'none',  
																		lg: 'none',  
																		xl: 'none',  																		
																		}}}> 
							<Box sx={{paddingTop: "0px"}}>
							</Box>	
		  				
						<center>
							<h2 style={{paddingTop: "40px", paddingBottom: "40px"}} class="headlineNewPoint">{t("immobilienbewertungIntro")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={1}>
					     		</Grid>
			        			<Grid item xs={10}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent1")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={1}>
					     		</Grid>
				     		</Grid>
			     		</Grid>
			     		
			     				  				
						<center>
							<h2 style={{paddingTop: "40px", paddingBottom: "20px"}} class="headlineNewPoint">{t("immobilienbewertungHeader2")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={1}>
					     		</Grid>
			        			<Grid item xs={10}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent2")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={1}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={1}>
					     		</Grid>
			        			<Grid item xs={10}>
									<Box sx={{paddingTop: "20px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent2b")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={1}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				

						<center>
							<h2 style={{paddingTop: "40px", paddingBottom: "20px"}} class="headlineNewPoint">{t("immobilienbewertungHeader3")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={1}>
					     		</Grid>
			        			<Grid item xs={10}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent3")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={1}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				

						<center>
							<h2 style={{paddingTop: "40px", paddingBottom: "20px"}} class="headlineNewPoint">{t("immobilienbewertungHeader4")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={1}>
					     		</Grid>
			        			<Grid item xs={10}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000"}}>					
											<p class="altFliessText" style={{margin: 0}}>
												<center>
													{t("immobilienbewertungContent4")}
												</center>											
											</p>
										</Box>			
									</Box>	
					     		</Grid>
			        			<Grid item xs={1}>
					     		</Grid>
				     		</Grid>
			     		</Grid>		  				

						</Box>
						
	
	   				</Box>
   		</>
   	)
}

export default function StartPage(props) {

  return <StartContent props={props}/>;
}